export const isProduction = import.meta.env.PROD;
export const isProductionMode = import.meta.env.MODE === 'production';
export const isDevelopment = import.meta.env.MODE === 'development';
export const isTesting = import.meta.env.MODE === 'test';
